import React from "react";
import ChildComponent from './child.js'
import { v4 as uuidv4 } from 'uuid';

export default class VillageRequestComponent extends React.Component {
  constructor(props) {
    super(props);
    this.villageRequestData = this.props.data;
    this.token = this.props.token;
    this.guardianId = this.props.guardianId;
    const { fromGuardian, guardianResponses, requestDetails } = this.villageRequestData;
    this.myResponse = guardianResponses.find((response) => response.nonMemberToken === this.token);

    this.name = this.myResponse.nonMemberName;
    this.state = {
      responseLink: '',
      responseDetails: '',
      villageRequestData: this.villageRequestData,
    };
  }

  // https://koy.parent-ai.com/villageRequest/?villageRequestId=86B02457-4AE0-4563-A655-B07733CF930C&phoneNumber=+14085555270&token=53697B11-1A56-4509-9774-558365798B2C
  // https://koy.parent-ai.com/villageRequest/?villageRequestId=5CEF163F-9A39-4A4C-93B1-1747A3E21566&phoneNumber=%2B15557664823&token=BEC0CD30-3A6C-4DEC-AE81-BC9C58FAEF16"	
  // http://localhost:3000/villageRequestLocal/?villageRequestId=DF38C4FF-48AB-4505-917E-A32130C41622&phoneNumber=%2B18885551212&token=9E7C674F-75CC-484A-8511-BB5A55264A74
  // type VillageResponse struct {
  // 	RequestId           string                `json:"requestId"`
  // 	HouseholdId         string                `json:"householdId"`
  // 	GuardianId          string                `json:"guardianId"`
  // 	Status              string                `json:"status"`
  // 	Notes               string                `json:"notes"`
  // 	AlternativeProposal VillageRequestDetails `json:"alternativeProposal"`
  // 	ActivityId          string                `json:"activityId"`
  // 	ActivityGroupId     string                `json:"activityGroupId"`
  // }
  handleInputChange = (event) => {
    this.setState({ responseDetails: event.target.value });
  };

  handleResponse = (response) => {
    let responseJson = {
      RequestId: this.villageRequestData.requestId,
      GuardianId: this.guardianId,
      Status: response,
      Notes: this.state.responseDetails,
      NonMemberToken: this.token,
      NonMemberName: this.name,

    }

    // send json 
    fetch(`${process.env.REACT_APP_API_BASE_URL}/putVillageResponse?token=` + this.token, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(responseJson),
    })
    console.log('Sent response: ', responseJson);

  }
  handleAccept = () => {
    this.handleResponse("Accepted");
  };

  handleDecline = () => {
    this.handleResponse("Declined");
  };

  /*
  
  Example villageRequestData:
{
    "activityGroupId": "",
    "activityId": "",
    "expirationTimestamp": 0,
    "fromGuardian": {
        "HouseholdId": "c6019383-27ea-4198-9c01-5f9208d90e03",
        "GuardianId": "26517a47-8a03-49c1-90bd-eb9ba134659a",
        "Name": "Can Envarli",
        "PhoneNumber": "+12063903958",
        "Email": "canenvarli@gmail.com",
        "WasInvitedToHousehold": false,
        "Children": null,
        "SignedTosTimestamp": 0,
        "SignedTosIP": ""
    },
    "guardianResponses": [
        {
            "villageRequestId": "DF38C4FF-48AB-4505-917E-A32130C41622",
            "guardian": {
                "HouseholdId": "",
                "GuardianId": "",
                "Name": "John",
                "PhoneNumber": "+18885551212",
                "Email": "",
                "WasInvitedToHousehold": false,
                "Children": null,
                "SignedTosTimestamp": 0,
                "SignedTosIP": ""
            },
            "status": "Pending",
            "notes": "",
            "alternativeProposal": null,
            "activityId": "",
            "activityGroupId": "",
            "nonMemberToken": "",
            "nonMemberName": ""
        },
        {
            "villageRequestId": "DF38C4FF-48AB-4505-917E-A32130C41622",
            "guardian": {
                "HouseholdId": "",
                "GuardianId": "",
                "Name": "John",
                "PhoneNumber": "+18885551212",
                "Email": "",
                "WasInvitedToHousehold": false,
                "Children": null,
                "SignedTosTimestamp": 0,
                "SignedTosIP": ""
            },
            "status": "Pending",
            "notes": "",
            "alternativeProposal": null,
            "activityId": "",
            "activityGroupId": "",
            "nonMemberToken": "9E7C674F-75CC-484A-8511-BB5A55264A74",
            "nonMemberName": "John"
        }
    ],
    "householdResponses": null,
    "requestDetails": {
        "ActivityId": "069eiosct8ur62ubqmliihc6um_20240311T214500Z",
        "ActivityStages": [
            "Dropoff",
            "Supervise",
            "Pickup"
        ],
        "ActivityTasks": [
            {
                "TaskDescription": "Dropoff",
                "Waypoints": [
                    "21343 NE 101st Ct\nRedmond, WA, United States",
                    ""
                ],
                "Timestamp": 1710193500,
                "TimestampIsForFinish": true
            },
            {
                "TaskDescription": "Supervise",
                "Waypoints": null,
                "Timestamp": 1710193501,
                "TimestampIsForFinish": false
            },
            {
                "TaskDescription": "Pickup",
                "Waypoints": [
                    "",
                    "21343 NE 101st Ct\nRedmond, WA, United States"
                ],
                "Timestamp": 1710196200,
                "TimestampIsForFinish": false
            }
        ],
        "Activity": {
            "ActivityId": "069eiosct8ur62ubqmliihc6um_20240311T214500Z",
            "ActivityGroupId": "DBBE7FB5-9B02-44B9-87BD-462AAA08A8BD",
            "OriginActivityId": "069eiosct8ur62ubqmliihc6um_20240311T214500Z",
            "Description": "School Pick Up",
            "HouseholdId": "c6019383-27ea-4198-9c01-5f9208d90e03",
            "Location": "",
            "CalendarName": "kristen.envarli@gmail.com",
            "CalendarSource": "Google",
            "StartTimeUTCSeconds": 1710193500,
            "EndTimeUTCSeconds": 1710196200,
            "ChildrenIds": [
                "824e7e33-fb46-464b-8fbb-ef5af58c5b2d",
                "ac627d75-81bc-4f69-a9e2-523451cc43a0"
            ],
            "Assignments": [],
            "HelperGuardianId": "",
            "HelpRequestId": "",
            "Household": {
                "HouseholdId": "",
                "Name": "",
                "Address": "",
                "LoggedInGuardianEmail": "",
                "LoggedInGuardianId": "",
                "Guardians": [],
                "Children": [],
                "isOnboarded": false
            }
        }
    },
    "requestId": "DF38C4FF-48AB-4505-917E-A32130C41622"
}
  */
  render() {
    const { fromGuardian, guardianResponses, requestDetails } = this.villageRequestData;
    const myResponse = guardianResponses.find((response) => response.nonMemberToken === this.token);
    const readableTimestamp = new Date(requestDetails.Activity.StartTimeUTCSeconds * 1000).toLocaleString();
    console.log('Guardian Tokens: ', guardianResponses.map((response) => response.nonMemberToken));

    return (
      <div>
        <h2>Hi {this.name}, {fromGuardian.Name} Needs Your Help!</h2>
        <p>Activity: {requestDetails.Activity.Description}</p>
        <p>Start Time: {readableTimestamp}</p>
        <table>
          <thead>
            <tr>
              <th>Task</th>
              <th>Start Time</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {requestDetails.ActivityTasks.map((task, index) => {
              return (
                <tr key={index}>
                  <td>{task.TaskDescription}</td>
                  <td>{new Date(task.Timestamp * 1000).toLocaleString()}</td>
                  <td>{
                    // check for task.Waypoints null
                    task.Waypoints === null ? <p>N/A</p> :
                      task.Waypoints.map((waypoint, index) => {
                        return <p key={index}>{waypoint}</p>;
                      }
                      )}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div>
          <label>
            Response Details:
            <input
              type="text"
              value={this.state.responseDetails}
              onChange={this.handleInputChange}
            />
          </label>
        </div>
        <button onClick={this.handleAccept}>Accept</button>
        <button onClick={this.handleDecline}>Decline</button>
      </div>
    );
  }

}